import axios from 'axios';
import axiosRetry from 'axios-retry';

const DEFAULT_RETRY_COUNT = 3;

/**
 * Creates an axios instance pre-wired with axios-retry.
 *
 * @param {string} baseURL - Base URL the instance will prefix on every request.
 * @param {import('axios').AxiosRequestConfig} [axiosOptions] - Extra axios
 *   options merged into the underlying `axios.create()` call.
 * @param {import('axios-retry').IAxiosRetryConfig} [retryOptions] - Retry
 *   configuration forwarded to axios-retry. Defaults to `DEFAULT_RETRY_COUNT`
 *   retries with an exponential backoff delay.
 * @returns {import('axios').AxiosInstance} Configured axios instance.
 */
export const APIAdapter = (
  baseURL,
  axiosOptions = {},
  retryOptions = {
    retries: DEFAULT_RETRY_COUNT,
    retryDelay: axiosRetry.exponentialDelay,
  },
) => {
  const axiosInstance = axios.create({
    baseURL,
    ...axiosOptions,
  });

  axiosRetry(axiosInstance, retryOptions);

  return axiosInstance;
};
